import React from 'react';
import { Identification } from 'components/identification';

export const IdentificationPage: React.FC = () => {
    return <Identification />;
};
